export class MxEnsureModuleLoadedOnceGuard {
  constructor(targetModule: any, onlyModuleName: string) {
    if (targetModule) {
      throw new Error(
        `${targetModule.constructor.name} has already been loaded. Import this module in the ${onlyModuleName} only.`
      );
    }
  }
}
